import React from 'react'
import PropTypes from 'prop-types'
import { bem } from '@argos/utils'
import { Avatar } from '../../Common'

const cn = bem({ prefix: 'lc-', block: 'typing-indicator' })

export class TypingIndicator extends React.Component {
  render() {
    const { participantName, isTyping } = this.props
    return (
      <div className={cn()}>
        <div className={`${cn('typing')} ${isTyping ? 'shown' : 'hidden'}`}>
          <Avatar agentName={participantName} type='agent' />
          <span className={cn('ellipsis', '1')} />
          <span className={cn('ellipsis', '2')} />
          <span className={cn('ellipsis', '3')} />
        </div>
      </div>
    )
  }

  static propTypes = {
    participantName: PropTypes.string,
    isTyping: PropTypes.bool,
  }

  static defaultProps = {
    participantName: '',
    isTyping: false,
  }
}
export default TypingIndicator
